import './NotificationPage.css';

import {
  useAppDispatch,
  useAppSelector,
} from 'app/hooks';
import {
  getNotificationData,
  selectNotification,
} from 'features/notifications/notificationSlice';
import { useEffect, useState } from 'react';
import { Markup } from 'interweave';

import PdfViewModal from 'components/elements/Modal/PdfViewModal'

const DownloadPage = () => {
  const dispatch = useAppDispatch();
  const {
    data, 
    pending, 
  } = useAppSelector(selectNotification);

  const [isPDFViewerOpen, setIsPDFViewerOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState('');

  useEffect(() => {
    
    dispatch(getNotificationData())
  }, [])

  
  const handleClose = () => {
    setIsPDFViewerOpen(false)
}

  const cardView = (item:any, index:number) => {
    return (
      <div className="card notification-card notification-invitation" key={'notification_'+index}>
        <div className="card-body">
          <table>
            <tr>
              <td style={{ width: "5%" }}>{item.file_type === 'application/pdf' ? <img src="images/pdf-icon.png" height={"70"} /> : <div className="notification-icon"><i className='fa fa-bell'/></div>}</td>
              <td>
                <div className="px-3"><Markup content={item.notification_headline} /></div>
              </td>
              <td style={{ width: "10%" }}>
              {item.file_type === 'application/pdf' && <button type="button" onClick={() => {
                    setSelectedPdf(item.file_link)
                    setIsPDFViewerOpen(true)
                }} className="btn btn-primary">View</button>}
              </td>
            </tr>
          </table>
        </div>
      </div>
    )
  }
  return (
  <>
    <div className="row notification-container notification p-3 h-100 overflow-auto">
      {/* <h2 className="text-center text-white pb-2">Downloads</h2> */}
      {data.map((item:any, key:number) => cardView(item, key))}
      
      <PdfViewModal title="PDF" link={selectedPdf} isOpen={isPDFViewerOpen} handleClose={handleClose}/>

    </div>
  </>
)
};

export default DownloadPage;
